<div class="bg">
  <div class="container">
    <div class="div-header text-center">
      <h3><i class="fas fa-user-edit"></i> Change Password</h3>
    </div>
    <div class="row">
      <div style="padding: 25px">
        <div>
          <form action="" [formGroup]="changepasswordForm" class="chnage-main">
            <div class="form-row">
              <mat-form-field class="material-full-width" appearance="outline">
                <mat-label
                  >Current Password<span class="text-danger">*</span></mat-label
                >
                <input
                  matInput
                  [type]="hide1 ? 'password' : 'text'"
                  formControlName="oldPassword"
                  placeholder="Enter Current Password"
                  [ngClass]="{
                    'is-invalid':
                      add.oldPassword.touched && add.oldPassword.errors
                  }"
                />
                <button
                  mat-icon-button
                  matSuffix
                  (click)="hide1 = !hide1"
                  [attr.aria-label]="'Hide password'"
                  [attr.aria-pressed]="hide1"
                >
                  <mat-icon>{{
                    hide1 ? "visibility_off" : "visibility"
                  }}</mat-icon>
                </button>
                <mat-error
                  *ngIf="add.oldPassword.touched && add.oldPassword.errors"
                >
                  <span *ngIf="add.oldPassword.errors.required"
                    >Current Password is required</span
                  >
                </mat-error>
              </mat-form-field>
            </div>
            <div class="form-row">
              <mat-form-field class="material-full-width" appearance="outline">
                <mat-label
                  >Enter New Password
                  <span class="text-danger">*</span></mat-label
                >
                <input
                  matInput
                  [type]="hide ? 'password' : 'text'"
                  formControlName="newPassword"
                  placeholder="Enter New Password"
                  [ngClass]="{
                    'is-invalid':
                      add.newPassword.touched && add.newPassword.errors
                  }"
                />
                <button
                  mat-icon-button
                  matSuffix
                  (click)="hide = !hide"
                  [attr.aria-label]="'Hide password'"
                  [attr.aria-pressed]="hide"
                >
                  <mat-icon>{{
                    hide ? "visibility_off" : "visibility"
                  }}</mat-icon>
                </button>
                <mat-error *ngIf="add.newPassword.errors?.mismatch">
                  Passwords do not match.
                </mat-error>
                <mat-error
                  *ngIf="add.newPassword.touched && add.newPassword.errors"
                >
                  <span *ngIf="add.newPassword.errors.required"
                    >New Password is required</span
                  >
                </mat-error>
              </mat-form-field>
            </div>
          </form>
        </div>
        <div class="text-center">
          <button class="login-btn new-btn-color" (click)="changePass()">
            <i class="far fa-save"></i> Save
          </button>
          <button class="login-btn new-btn-color2" (click)="cancelReg()">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
